import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/ScmTypes";
import { IStockBorrowDetail, IStockBorrowSearch, IStockBorrowField, IExportBorrowField } from "./stockOutAndInListType"
class StockOutAndInListService {
    async page(searchVo: IStockBorrowSearch) {
        const apiUrl = "/zzw-vrm/borrow/findPage";
        return await httpRequest.post<IPage<IStockBorrowDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/borrow/findById/${id}`;
        return await httpRequest.get<IStockBorrowDetail>(apiUrl);
    }
    async insert(insertVo: IStockBorrowField) {
        const apiUrl = "/zzw-vrm/borrow/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IStockBorrowField) {
        const apiUrl = "/zzw-vrm/borrow/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //退料入库
    async storage(updateVo: IStockBorrowField) {
        const apiUrl = "/zzw-vrm/borrow/storage";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async exportFind(exportParams: IExportBorrowField) {
        const apiUrl = "/zzw-vrm/borrow/export";
        return await httpRequest.postFile<boolean>(apiUrl, exportParams, { timeout: 300000 });
    }
}

export const stockOutAndInListService = new StockOutAndInListService();